import React, { useEffect, useState } from 'react';
import '../styles/SideBarRight.css';
import '../styles/SideBarToggle.css';

import CollapseIconHover from '../../images/IconRightArrowBlue@3x.png';
import CollapseIcon from '../../images/IconRightArrowGrey@3x.png';
import PlaceholderImage from '../../images/PlaceholderImage.png';
import ComingSoonImage from '../../images/ComingSoonWeb.png';
import IconClear from '../../images/IconClear@3x.png';
import IconClearBlue from '../../images/IconClearBlue@3x.png';

export default function StockSideBarRight({
  isExpanded = true,
  onRequestClose = () => { },
  selectedListing,
  showEditListingButton = false,
  onEditListing = () => { },
  clearSelection = () => { },
}) {
  const [isSideBarCollapseButtonHovering, setIsSideBarCollapseButtonHovering] = useState(false);
  const [isSidebarVisible, setIsSidebarVisible] = useState(isExpanded);
  const [shouldRenderContent, setShouldRenderContent] = useState(isExpanded);
  const [isClearListingButtonHovered, setIsClearListingButtonHovered] = useState(false);

  useEffect(() => {
    if (isExpanded) {
      setShouldRenderContent(true);
      setIsSidebarVisible(true);
      setIsSideBarCollapseButtonHovering(false);
    } else {
      setIsSidebarVisible(false);
      setTimeout(() => setShouldRenderContent(false), 300);
    }
  }, [isExpanded]);

  const isComingSoon = selectedListing?.progress === 'Coming Soon';

  const openBrochure = () => {
    const url =
      typeof selectedListing?.brochure === 'string'
        ? selectedListing.brochure
        : selectedListing?.brochure?.url;

    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  };

  const renderPublicIntro = () => (
    <div className="sidebarRight-empty">
      <div className="sidebarRight-onboarding">
        <div className="sidebarRight-onboarding-step">
          <div className="sidebarRight-onboarding-step-header">Your First Fraemohs – But Certainly Not Your Last</div>
          <div className="sidebarRight-onboarding-step-text">
            <p>Whether you're stepping onto the property ladder or expanding your investment portfolio, the Fraemohs First Turnkey Home Range is your perfect starting point.</p>
            <p>Designed with affordability in mind, these homes deliver the same trusted quality, craftsmanship, and timeless style that Fraemohs is known for. Ideal for first-home buyers and savvy investors alike, this range proves that you don’t have to compromise on sophistication to make a smart move.</p>
            <p>It may be your first Fraemohs — but it won’t be your last.</p>
          </div>
        </div>

        <div className="sidebarRight-onboarding-step">
          <div className="sidebarRight-onboarding-step-header">Easy Payment Terms</div>
          <div className="sidebarRight-onboarding-step-text">
            <p>If you purchase before the build is finished, you can secure the house with a 5% deposit and the balance on completion.</p>
            <p>If you are purchasing a completed home, this is handled like a normal real estate transaction.</p>
          </div>
        </div>

        <div className="sidebarRight-onboarding-step">
          <div className="sidebarRight-onboarding-step-header">Enquire Now</div>
          <div className="sidebarRight-onboarding-step-text">
            <p>Visit the TradeMe listing to make an enquiry on a specific package.</p>
          </div>
        </div>
      </div>
    </div>
  );

  const renderSelectedListing = () => (
    <div className="sidebarRight-plan">
      <img
        src={isComingSoon ? ComingSoonImage : selectedListing.thumbnail || PlaceholderImage}
        alt={isComingSoon ? 'Coming Soon' : 'Listing'}
        className={`sidebarRight-plan-image${isComingSoon ? ' sidebarRight-plan-image-coming-soon' : ''}`}
      />

      {!isComingSoon && (
        <div
          className="sidebarRight-plan-info-title"
          style={{
            marginTop: 20,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              fontWeight: 600,
              fontSize: 16,
              flex: 1,
              marginRight: 16,
              wordBreak: 'break-word',
            }}
          >
            {selectedListing.displayTitle}
          </div>
          <button
            onClick={() => {
              clearSelection();
              setIsClearListingButtonHovered(false);
            }}
            title="Clear selection"
            style={{
              background: 'none',
              border: 'none',
              marginLeft: 'auto',
              padding: 0,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              src={isClearListingButtonHovered ? IconClearBlue : IconClear}
              alt="Clear Plan Info"
              onMouseEnter={() => setIsClearListingButtonHovered(true)}
              onMouseLeave={() => setIsClearListingButtonHovered(false)}
              style={{
                height: '18px',
                width: '18px',
                cursor: 'pointer',
                borderRadius: '50%',
                transition: 'box-shadow 0.2s ease',
                boxShadow: isClearListingButtonHovered
                  ? 'var(--ph-box-shadow-hover)'
                  : 'none',
              }}
            />
          </button>
        </div>
      )}

      {isComingSoon && selectedListing.locationString && (
        <div className="sidebarRight-landinfo-section sidebarRight-coming-soon-section">
          <div className="sidebarRight-landinfo-row sidebarRight-coming-soon-row">
            <span className="label">
              {selectedListing.locationString}
            </span>
          </div>
        </div>
      )}

      {!isComingSoon && (
        <div className="sidebarRight-collapsible-content expanded">
          {selectedListing.locationString && (
            <div>
              <div className="sidebarRight-plan-info-size" style={{ fontSize: '14px', marginRight: '50px', marginTop: '5px' }}>
                <span>{selectedListing.locationString}</span>
              </div>
            </div>
          )}

          <>
            <div className="sidebarRight-landinfo-section" style={{ marginTop: 30 }}>
              {selectedListing.availability && (
                <div className="sidebarRight-landinfo-row">
                  <span className="label">Availability:</span>
                  <span className="value">{selectedListing.availability.toUpperCase()}</span>
                </div>
              )}
              {selectedListing.progress && (
                <div className="sidebarRight-landinfo-row">
                  <span className="label">Stage:</span>
                  <span className="value">{selectedListing.progress}</span>
                </div>
              )}
              {selectedListing.price && (
                <div className="sidebarRight-landinfo-row" style={{ justifyContent: 'center', textAlign: 'center' }}>
                  <span className="label">{selectedListing.price}</span>
                </div>
              )}
            </div>

            <div className="sidebarRight-landinfo-section" style={{ marginTop: 20 }}>
              {selectedListing.floorArea && (
                <div className="sidebarRight-landinfo-row">
                  <span className="label">Floor Area:</span>
                  <span className="value">{selectedListing.floorArea.toLocaleString()} m²</span>
                </div>
              )}
              {selectedListing.landArea && (
                <div className="sidebarRight-landinfo-row">
                  <span className="label">Land Area:</span>
                  <span className="value">{selectedListing.landArea.toLocaleString()} m²</span>
                </div>
              )}
              {selectedListing.bedrooms != null && (
                <div className="sidebarRight-landinfo-row">
                  <span className="label">Bedrooms:</span>
                  <span className="value">{selectedListing.bedrooms}</span>
                </div>
              )}
              {selectedListing.bathrooms != null && (
                <div className="sidebarRight-landinfo-row">
                  <span className="label">Bathrooms:</span>
                  <span className="value">{selectedListing.bathrooms}</span>
                </div>
              )}
            </div>
          </>
        </div>
      )}

      {isComingSoon && (
        <div
          className="sidebarRight-landinfo-row sidebarRight-coming-soon-contact-row"
          onClick={() => window.open('mailto:sales@fraemohs.co.nz?subject=House%20and%20land%20query')}
        >
          <span>Contact us at:</span>
          <span>sales@fraemohs.co.nz</span>
        </div>
      )}

      {!isComingSoon && selectedListing.brochure && (
        <div>
          <div
            className="sidebarRight-landinfo-row"
            onClick={openBrochure}
            style={{
              marginBottom: '30px',
              backgroundColor: 'var(--phbluewashed)',
              fontSize: '14px',
              fontWeight: 600,
              justifyContent: 'center',
              textAlign: 'center',
              color: 'var(--phblueaccent)',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease, color 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--phblue)';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--phbluewashed)';
              e.currentTarget.style.color = 'var(--phblueaccent)';
            }}
          >
            <span>Brochure ›</span>
          </div>
        </div>
      )}

      {!isComingSoon && selectedListing.trademeURL && (
        <div>
          <div
            className="sidebarRight-landinfo-row"
            onClick={() => window.open(selectedListing.trademeURL, '_blank')}
            style={{
              backgroundColor: 'var(--phgreenwashed)',
              fontSize: '14px',
              fontWeight: 600,
              justifyContent: 'center',
              textAlign: 'center',
              color: 'var(--phgreenfont)',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease, color 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--phgreenfont)';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--phgreenwashed)';
              e.currentTarget.style.color = 'var(--phgreenfont)';
            }}
          >
            <span>View and Enquire on TradeMe ›</span>
          </div>
        </div>
      )}

      {showEditListingButton && (
        <div className="sidebarRight-admin-actions">
          <button
            type="button"
            className="sidebarRight-landinfo-row sidebarRight-admin-edit-row"
            onClick={onEditListing}
          >
            <span>Edit Listing (admin) ›</span>
          </button>
        </div>
      )}
    </div>
  );

  return (
    <div
      className="sidebarRight"
      style={{
        width: '100%',
        flex: 1,
        opacity: isSidebarVisible ? 1 : 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        borderLeft: isExpanded ? '0.75px solid #596A99' : 'none',
        transition: 'flex-basis 0.3s ease, opacity 0.3s ease',
        position: 'relative',
      }}
    >
      {isExpanded && (
        <button
          className="sidebar-toggle-button sidebar-right-toggle-button-expanded"
          onClick={onRequestClose}
          onMouseEnter={() => setIsSideBarCollapseButtonHovering(true)}
          onMouseLeave={() => setIsSideBarCollapseButtonHovering(false)}
        >
          <img
            src={isSideBarCollapseButtonHovering ? CollapseIconHover : CollapseIcon}
            alt="Hide Sidebar"
          />
        </button>
      )}

      {shouldRenderContent && (
        <div className="sidebarRight-inner">
          <div className="sidebarRight-scrollable">
            <div className="sidebarRight-scrollarea">
              {selectedListing ? renderSelectedListing() : renderPublicIntro()}
              <div className="sidebarRight-version">v1.0</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
